import { render } from "./notificaAnnounc.vue?vue&type=template&id=95719c60&scoped=true"
const script = {}

import "./notificaAnnounc.vue?vue&type=style&index=0&id=95719c60&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95719c60"]])

export default __exports__